module.exports = __webpack_public_path__ + "static/media/85.0971ff28.png";